var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_vm._m(0),_c('div',{staticClass:"main-area"},[_c('TeamshootSignComponent',{staticClass:"sign"})],1)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('nav',{staticClass:"navbar"},[_c('a',{staticClass:"navbar-brand",attrs:{"href":"https://stickerfive.de"}},[_c('img',{staticClass:"company-logo",attrs:{"src":require("./assets/letterBlack.svg"),"height":"38","alt":"Stickerfive"}})])])
}]

export { render, staticRenderFns }